export enum LogoSize {
	ExtraLarge = 120,
	Large = 100,
	Medium = 80,
	SmallPlus = 56,
	Small = 50,
	Hidden = 0,
}
